import React, { FC } from 'react'
import { Typography, DialogActions, Button, Box, CircularProgress } from '@mui/material'
import { StatefulDialog } from 'src/components/ui'
import { DialogNames } from 'src/enums'

interface UnarchiveUserModalProps {
  userName: string;
  onUnarchive: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const UnarchiveUserModal: FC<UnarchiveUserModalProps> = ({
  userName,
  onUnarchive,
  onCancel,
  isLoading = false,
}) => {
  return (
    <StatefulDialog
      name={DialogNames.UnarchiveUser}
      actions={
        <Box mb={2} mx={2}>
          <DialogActions>
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={onUnarchive}
              disabled={isLoading}
            >
              { isLoading ? <CircularProgress color="info" size={26} /> : 'Unarchive' }
            </Button>
          </DialogActions>
        </Box>
      }
    >
      <Box minWidth="300px">
        <Typography variant="h6">Are you sure you want to unarchive the user {userName}?</Typography>
      </Box>
    </StatefulDialog>
  )
}
